/* eslint-disable */
import React from 'react'
import Page from '../../Component/Pagination/Pagination'
import http from '../../Component/Interceptor/Interseptor'
import HeaderTable from '../BaseComponent/HeaderTable'
import {Link} from 'react-router-dom'
import {message} from 'antd'
import jMoment from 'moment-jalaali'

import $ from 'jquery'
import cookie from 'react-cookies'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import WAREHOUSE from '../BaseComponent/WAREHOUSE'
import FromToPicker from '../BaseComponent/FromToPicker'
import SortTable from '../BaseComponent/SortTable'
import {convertMonth} from '../utils/convert'
import HeaderGrid from '../Pagination/HeaderGrid'
import Sort from '../Pagination/Sort'
import Pageing from '../Pagination/pageing'
import Loader from '../loaders/loader'

class AverageProduct extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      reportTransferCost: [],
      total: 0,
      printInfo: [],
      grouping: '',
      aggregation: {},
      buttonClicked: false,
      providers: [],
      providerIdObject: [],
      providerIds: [],
      warehouses: [],
      warehousesObjects: [],
      warehouseIds: [],
      fromRegDate: '',
      toRegDate: '',
      pageNumber: 1,
      pageSize: 10,
      countAll: 0,
      sortBy: '',
      getSort: '',

      sortData: [
        {
          name: 'ردیف',
          value: 'id',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'روز',
          value: 'purchaseDay',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'روز هفته',
          value: 'purchaseWeekDay',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'ماه',
          value: 'purchaseMonth',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'فصل',
          value: 'purchaseSeason',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'سال',
          value: 'purchaseYear',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'تعداد خرید',
          value: 'purchaseCount',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'جمع',
          value: 'invoiceItemCountSum',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'میانگین',
          value: 'invoiceItemCountAvg',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'ماکزیمم',
          value: 'invoiceItemCountMax',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'مینیمم',
          value: 'invoiceItemCountMin',
          sorted: false,
          direction: null,
          sortable: true
        }
      ],
      sortResult: 'sortBy='
    }
  }
  componentDidMount() {
    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
    $(function() {
      $('.filterBtn').on('click', function() {
        $('.basketFilterComponent').slideToggle()
      })
    })

    http
      .get(`${WAREHOUSE.WAREHOUSE_TYPE_LIST_WAREHOUSE}`, {})
      .then((response) => {
        if (response.data.error === null) {
          var result = response.data.object
          for (let i = 0; i < result.length; i++) {
            result[i]['value'] = result[i].id
            result[i]['label'] = result[i].id + ' - ' + result[i].name
          }
          this.setState({
            warehouses: response.data.object
          })
        } else {
          this.setState({
            warehouses: []
          })
        }
      })
      .catch((error) => {
        console.log(error)
      })

    http
      .get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`, {})
      .then((response) => {
        if (response.data.error == null) {
          var result = response.data.object
          for (let i = 0; i < result.length; i++) {
            result[i]['value'] = result[i].providerId
            result[i]['label'] = result[i].providerId + ' - ' + result[i].title
          }

          this.setState({
            providers: response.data.object
          })
        }
        // alert(JSON.stringify(response.data))
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }
  getAverage = (exportStatus) => {
    let filter = this.createFilter(exportStatus)
    this.setState({
      loading: true
    })
    http
      .get(`${REPORT_RETAIL.REPORT_RETAIL_PURCHASE_INVOICEITEM}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error === null) {
          $('.showBaseTable,.print').fadeIn()
          this.setState({
            reportTransferCost: response.data.object.result,
            total: response.data.object.countAll,
            getGrouping: this.state.grouping,
            aggregation: response.data.object.aggregation,
            buttonClicked: true,
            loading: false
          })
        } else {
          $('.showBaseTable,.print').fadeOut()
          this.setState({
            reportTransferCost: [],
            total: 0,
            loading: false
          })
          // message.error(response.data.description)
        }
      })
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.pageNumber !== this.state.pageNumber) {
      this.getAverage(false)
    }
    if (prevState.pageSize !== this.state.pageSize) {
      this.getAverage(false)
    }
    if (prevState.sortBy !== this.state.sortBy) {
      this.getAverage(false)
    }
  }
  getPageNumber = (pageNumber) => {
    this.setState({
      pageNumber
    })
  }
  getPageSize = (pageSize) => {
    this.setState({
      pageSize,
      pageNumber: 1
    })
  }
  getSort = (sortBy) => {
    this.setState({
      sortBy
    })
  }

  onResultFetched(data) {
    this.setState({
      reportTransferCost: data
    })
  }

  changeDropDown(data) {
    this.setState({
      reportTransferCost: data,
      lengthProducts: sessionStorage.getItem('countAll')
    })
  }

  sortFunction = (reportTransferCost, sortResult) => {
    this.setState({
      reportTransferCost,
      sortResult
    })
  }

  changeGrouping = (e) => {
    let target = e.target

    this.setState({
      grouping: target.options[target.selectedIndex].text
    })
  }

  handleChangeFromRegDate = (fromRegDate) => {
    this.setState({
      fromRegDate
    })
  }

  handleChangeToRegDate = (toRegDate) => {
    this.setState({
      toRegDate
    })
  }

  convertDayName = (dayNumber) => {
    switch (dayNumber) {
      case 1:
        return 'شنبه'
        break
      case 2:
        return 'یکشنبه'
        break
      case 3:
        return 'دوشنبه'
        break
      case 4:
        return 'سه شنبه'
        break
      case 5:
        return 'چهارشنبه'
        break
      case 6:
        return 'پنجشنبه'
        break
      case 7:
        return 'جمعه'
        break
      default:
        return ''
    }
  }

  convertSeason = (dayNumber) => {
    switch (dayNumber) {
      case 1:
        return 'بهار'
        break
      case 2:
        return 'تابستان'
        break
      case 3:
        return 'پاییز'
        break
      case 4:
        return 'زمستان'
        break
      default:
        return ''
    }
  }
  createFilter = (exportStatus) => {
    let filter = {}
    let grouping = document.getElementById('grouping').value
    let invoiceDateMin = this.state.fromRegDate
    let invoiceDateMax = this.state.toRegDate

    filter.pageNumber = this.state.pageNumber
    filter.pageSize = this.state.pageSize
    filter.export = exportStatus
    if (this.state.sortBy !== '') {
      filter.sortBy = this.state.sortBy
    }

    if (grouping !== '' && grouping.length) {
      filter.grouping = grouping
    }

    if (invoiceDateMin !== '') {
      filter.invoiceDateMin = invoiceDateMin
    }

    if (invoiceDateMax !== '') {
      filter.invoiceDateMax = invoiceDateMax
    }

    return filter
  }

  filter() {
    if (Object.keys(this.createFilter(false)).length - 3 === 0) {
      message.error('حداقل یک فیلتر وارد شود')
    } else {
      this.setState(
        {
          pageNumber: 1
        },
        () => {
          this.getAverage(false)
        }
      )
    }
  }

  getPrintInfo = () => {
    let filter = this.createFilter(true)
    this.setState({
      loading: true
    })

    http
      .get(`${REPORT_RETAIL.REPORT_RETAIL_PURCHASE_INVOICEITEM}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error === null) {
          // alert(JSON.stringify(response.data))
          this.setState({
            printInfo: response.data.object.result,
            aggregation: response.data.object.aggregation,
            loading: false
          })
          setTimeout(() => {
            window.print()
          }, 2000)
        } else {
          this.setState({
            printInfo: [],
            loading: false
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
  }

  exportExcel = () => {
    let filter = this.createFilter(true)
    http
      .get(`${REPORT_RETAIL.REPORT_RETAIL_PURCHASE_INVOICEITEM}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            excelReport: response.data.object.result
          })
          let {excelReport} = this.state
          for (let i = 0; i < excelReport.length; i++) {
            excelReport[i]['month'] = convertMonth(excelReport[i]['month'])
            excelReport[i]['season'] = this.convertSeason(excelReport[i]['season'])
            excelReport[i]['weekDay'] = this.convertDayName(excelReport[i]['weekDay'])
          }
          this._export.save(this.state.excelReport)
        }
      })
  }

  getValueProvider = (providerIdObject) => {
    var providerArr = []
    this.setState({
      providerIdObject
    })
    if (providerIdObject.length == '0') {
      this.setState({
        providerIds: []
      })
    } else {
      for (let prop of providerIdObject) {
        providerArr.push(prop.providerId)
        this.setState({
          providerIds: providerArr
        })
      }
    }
  }

  render() {
    let {pageNumber, pageSize, loading} = this.state
    let urlParams = sessionStorage.getItem('params')
    let reporterName = cookie.load('name')
    let printCol = ['ردیف', 'روز', 'روز هفته', 'ماه', 'فصل', 'سال', 'تعداد خرید', 'جمع', 'میانگین', 'ماکزیمم', 'مینیمم']

    return (
      <div className="rtl printA4Page">
        <Loader show={loading} />
        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="میانگین کالای هر فاکتور.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'purchaseDay'}
                field={'purchaseDay'}
                title={'روز'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'purchaseWeekDay'}
                field={'purchaseWeekDay'}
                title={'روز هفته'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'purchaseMonth'}
                field={'purchaseMonth'}
                title={'ماه'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'purchaseSeason'}
                field={'purchaseSeason'}
                title={'فصل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'purchaseYear'}
                field={'purchaseYear'}
                title={'سال'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'purchaseCount'}
                field={'purchaseCount'}
                title={'تعداد'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'invoiceItemCountSum'}
                field={'invoiceItemCountSum'}
                title={'کل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'invoiceItemCountAvg'}
                field={'invoiceItemCountAvg'}
                title={'میانگین'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'invoiceItemCountMax'}
                field={'invoiceItemCountMax'}
                title={'ماکزیمم'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'invoiceItemCountMin'}
                field={'invoiceItemCountMin'}
                title={'مینیمم'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>
        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="میانگین کالای هر فاکتور"
              reporter={reporterName}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              headerColSpan={11}
              rightColSpan={5}
              centerColSpan={1}
              leftColSpan={5}
              centerSection={''}
              rightSection={' گزارش ' + this.state.getGrouping}
              columns={printCol}
            />

            <tbody>
              {this.state.printInfo.map((list, index) => (
                <tr key={'i' + index} style={index % 2 == 0 ? {backgroundColor: '#f1f1f1'} : {backgroundColor: '#fff'}}>
                  <td>{index + 1}</td>
                  <td>{list.time.day}</td>
                  <td>{this.convertDayName(list.time.weekDay)}</td>
                  <td>{convertMonth(list.time.month)}</td>
                  <td>{this.convertSeason(list.time.season)}</td>
                  <td>{list.time.year}</td>
                  <td>{list.purchaseCount}</td>
                  <td>{list.invoiceItemCountSum}</td>
                  <td>{list.invoiceItemCountAvg}</td>
                  <td>{list.invoiceItemCountMax}</td>
                  <td>{list.invoiceItemCountMin}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>خرید و فروش</li>
            <li>میانگین کالای هر فاکتور</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderGrid
                  getPageSize={this.getPageSize}
                  createLink={'/report/retail/purchase/invoiceItem'}
                  enablePageSize
                />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button
                  className={'printButton'}
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportExcel}
                >
                  <i className="fas fa-file-excel" />
                </button>
                <button
                  className="printButton"
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportPrint}
                >
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="basketFilterComponent">
              <div className="filterInputs">
                <FromToPicker
                  onChangeFromDate={this.handleChangeFromRegDate}
                  onChangeToDate={this.handleChangeToRegDate}
                  fromLabel="تاریخ ثبت از"
                  toLabel="تاریخ ثبت تا"
                  defaulValue
                  fromId="fromReg"
                  toId="toReg"
                />

                <div className="formComponent">
                  <label>بازه</label>
                  <select className="form-control" onChange={this.changeGrouping} id="grouping">
                    <option value="day">روزانه</option>
                    <option value="weekDay">روز هفته</option>
                    <option value="month">ماهانه</option>
                    <option value="season">فصل</option>
                    <option value="year" selected>
                      سالانه
                    </option>
                  </select>
                </div>
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>
            <div className="showBaseTable print">
              <table className="baseTable">
                <tbody>
                  <Sort data={this.state.sortData} getSort={this.getSort} />

                  {this.state.reportTransferCost.map((list, index) => (
                    <tr key={index}>
                      <td>{(pageNumber - 1) * pageSize + index + 1}</td>
                      <td>{list.time.day}</td>
                      <td>{this.convertDayName(list.time.weekDay)}</td>
                      <td>{convertMonth(list.time.month)}</td>
                      <td>{this.convertSeason(list.time.season)}</td>
                      <td>{list.time.year}</td>
                      <td>{list.purchaseCount}</td>
                      <td>{list.invoiceItemCountSum}</td>
                      <td>{list.invoiceItemCountAvg}</td>
                      <td>{list.invoiceItemCountMax}</td>
                      <td>{list.invoiceItemCountMin}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <div className="paginationWrapp">
                <Pageing
                  defaultCurrent={1}
                  getPage={this.getPageNumber}
                  pageSize={this.state.pageSize}
                  currentPage={this.state.pageNumber}
                  total={this.state.total}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default AverageProduct
